import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const ItemWrapper = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  gap: 8px;
  padding: 6px 12px 6px 8px;
  border-radius: 4px;
  border: 1px solid;
  border-color: ${({ theme, $isSelected }) =>
    $isSelected ? `${theme.colors.green7}` : `${theme.colors.black4}`};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green2 : theme.colors.white};
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
  &:hover {
    background-color: ${({ theme, $isSelected }) =>
      $isSelected ? theme.colors.green2 : theme.colors.green1};
  }
`;
